export const MIN_QUANTITY = 1;
export const QUANTITY_MAX_FRACTION_DIGITS = 2;
export const QUANTITY_PATTERN = new RegExp(
  `^\\d+(\\.\\d{1,${QUANTITY_MAX_FRACTION_DIGITS}})?$`,
);
